import React from 'react';
import MyDatePicker from '../../components/DatePicker/DatePicker';
import { DateWrapper, FilterWrapper } from './FilterWithDate.styled';
import {
  filter_icon,
  filter_icon_vector,
  reset_icon,
  share_icon,
} from '../SvgIcon/CommonSvgIcons';

const FilterWithDate = ({
  job_id,
  startDate,
  initialStartDate,
  dateHandler,
  formatValue,
  endDate,
  initialEndDate,
  showSave,
  dateSubmit,
  handleReset,
  handleFilter,
  handleShareClick,
}) => {
  return (
    <FilterWrapper>
      <DateWrapper>
        <div>
          <div style={{ color: '#2a2929' }}>
            First Post Date:
          </div>
          <MyDatePicker
            width='110px'
            name='firstPostDate'
            value={startDate || initialStartDate}
            dateHandler={dateHandler}
            format={formatValue}
            min={initialStartDate}
            max={initialEndDate}
            readOnlyvalue={true}
          />
        </div>

        <div>
          <div style={{ color: '#2a2929' }}>
            Last Post Date:
          </div>
          <MyDatePicker
            width='110px'
            name='lastPostDate'
            value={endDate || initialEndDate}
            dateHandler={dateHandler}
            format={formatValue}
            min={startDate}
            max={initialEndDate}
            readOnlyvalue={true}
          />
        </div>

        {/* Optional Save/Reset buttons if needed later */}
        {/* {typeof job_id === 'number' && (showSave ?
          (
            <button className='button' onClick={dateSubmit}>
              Save
            </button>
          )
          :
          (
            <button className='button' onClick={handleReset}>
              Reset
              {reset_icon}
            </button>
          )
        )} */}
      </DateWrapper>

      <div className='buttonContainer'>
        <button className='button-custom' onClick={handleFilter}>
          Customize View
          {filter_icon_vector}
        </button>

        {typeof job_id === 'number' && (
          <button className='button' onClick={handleShareClick}>
            Share
            {share_icon}
          </button>
        )}
      </div>
    </FilterWrapper>
  );
};

export default FilterWithDate;
